// @flow
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { withRouter } from 'react-router-dom';
import type { Dispatch } from 'redux';
import React from 'react';
import { OmniNav } from '@finect/tabular-omninav';
import { finect as theme } from '@finect/tabular-themes/finect';
import CookiesCMP from '@finect/front-core/CookiesCMP';
import { isPreRelease } from '@finect/front-utils/isPreRelease';
import { reset } from '@finect/tabular-utils/reset';
import { Main } from '@finect/tabular-core/Main';
import { Content } from '@finect/tabular-core/Content';
import { Footer } from '@finect/tabular-components/Footer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getLoggedUser, fetchUserNotifications } from '@finect/front-core/User';

const DONT_SHOW_COOKIES = ['/terminos-legales/politica-de-cookies', '/terminos-legales'];

/* eslint-disable */
const GlobalStyles = createGlobalStyle`
  ${reset};

  :root {
    --primaryColor: #DCE1F5;
    --secondaryColor: #FF5277;

    --gradient-main: linear-gradient(180deg, #3C44D7 0%, #6E41A9 23%, #3C44D7 77.5%, #E2E2E2 100%);
    --gradient-secondary: linear-gradient(0deg, #4c53d100 0%, #4C53D1 3.92%, #2A30A8 28.5%, #2A2D67 100%);
    --gradient-text: linear-gradient(180deg, #F1F1F1 0%, #BEC3F5 100%);
  }
`;
/* eslint-enable */

theme.partner.routes = {
  GroupArticles: '/grupos/:slug/articulos',
  GroupArticle: '/grupos/:slug/articulos/:id',

  AdvisorArticles: '/usuario/:alias/articulos',
  AdvisorArticle: '/usuario/:alias/articulos/:articleAlias'
};

export function fetchAppInitialData(cookie: string = 'include') {
  return function (dispatch: Dispatch, getState: Function) {
    const promises = [];
    if (!getState().user.user.hasOwnProperty('isLoggedIn')) {
      promises.push(dispatch(getLoggedUser(cookie)));
    }

    return Promise.all(promises);
  };
}

const mapStateToProps = state => ({
  user: state.user.user
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getLoggedUser,
      fetchUserNotifications,
      fetchAppInitialData
    },
    dispatch
  )
});

type Props = {
  user: Object,
  actions: Object,
  children: any,
  omniNavData?: Object,
  location?: Object
};

class App extends React.Component<Props> {
  componentDidMount() {
    this.props.actions.fetchAppInitialData();
  }

  static loadInitialData(store, cookie) {
    return store.dispatch(fetchAppInitialData(cookie));
  }

  newsletterAction = (preferences: Object) => {
    this.props.actions.fetchUserNotifications(preferences);
  };

  render() {
    if (!this.props.user.hasOwnProperty('isLoggedIn')) return null;

    const { user, location, children, omniNavData } = this.props;
    const pathname = location ? location.pathname : null;

    return (
      <ThemeProvider theme={theme}>
        <CookiesCMP user={user} loadAsSubscribed={DONT_SHOW_COOKIES.some(url => pathname === url)} cmpDomain={isPreRelease ? 'consent.finect.com' : 'cdn.privacy-mgmt.com'} />

        <Main>
          <GlobalStyles />
          <OmniNav user={this.props.user} finectApp="front-others" omniNavData={omniNavData} />
          <Content>{children}</Content>
          <Footer current="others" user={user} newsletterAction={this.newsletterAction} />
        </Main>
      </ThemeProvider>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

export const AppWithRouter = withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
